import _ from 'lodash';

class ReactHelper {
  static basicShouldComponentUpdate = (
    currentProps,
    currentState,
    nextProps,
    nextState,
    propKeys,
    objectPropKeys,
    arrayPropKeys,
    nestedPropKeys,
  ) => {
    const propKeysLocal = propKeys || [];
    const objectPropKeysLocal = objectPropKeys || [];
    const arrayPropKeysLocal = arrayPropKeys || [];
    const nestedPropKeysLocal = nestedPropKeys || [];

    for (let i = 0, ii = propKeysLocal.length; i < ii; i += 1) {
      if (currentProps && nextProps && currentProps[propKeysLocal[i]] !== nextProps[propKeysLocal[i]]) {
        return true;
      }

      if (currentState && nextState && currentState[propKeysLocal[i]] !== nextState[propKeysLocal[i]]) {
        return true;
      }
    }

    for (let i = 0; i < objectPropKeysLocal.length; i += 1) {
      if (
        currentProps &&
        nextProps &&
        !_.isEqual(currentProps[objectPropKeysLocal[i]], nextProps[objectPropKeysLocal[i]])
      ) {
        return true;
      }

      if (
        currentState &&
        nextState &&
        !_.isEqual(currentState[objectPropKeysLocal[i]], nextState[objectPropKeysLocal[i]])
      ) {
        return true;
      }
    }

    for (let i = 0; i < arrayPropKeysLocal.length; i += 1) {
      if (
        currentProps &&
        nextProps &&
        !_.isEqual({array: currentProps[arrayPropKeysLocal[i]]}, {array: nextProps[arrayPropKeysLocal[i]]})
      ) {
        return true;
      }

      if (
        currentState &&
        nextState &&
        !_.isEqual({array: currentState[arrayPropKeysLocal[i]]}, {array: nextState[arrayPropKeysLocal[i]]})
      ) {
        return true;
      }
    }

    for (let i = 0; i < nestedPropKeysLocal.length; i += 1) {
      if (
        currentProps &&
        nextProps &&
        _.isEqual(
          JSON.stringify(currentProps[nestedPropKeysLocal[i]]),
          JSON.stringify(nextProps[nestedPropKeysLocal[i]]),
        )
      ) {
        return true;
      }

      if (
        currentState &&
        nextState &&
        _.isEqual(
          JSON.stringify(currentState[nestedPropKeysLocal[i]]),
          JSON.stringify(nextState[nestedPropKeysLocal[i]]),
        )
      ) {
        return true;
      }
    }

    return false;
  };

  static fixedNum = (value, precission) => {
    let val = parseFloat(value);
    let pres = 3;

    if (Number.isNaN(val)) val = 0;
    if (precission) pres = precission;

    return +parseFloat(val).toFixed(pres);
  };
}

export default ReactHelper;
